import { render } from "./HistoryOfView.vue?vue&type=template&id=e82ba814"
import script from "./HistoryOfView.vue?vue&type=script&lang=js"
export * from "./HistoryOfView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ktl/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__